import React from 'react'
import { Container, Header } from 'semantic-ui-react'

const HomeLayout = () => (
  <div>
    <Container text style={{ marginTop: '7em' }}>
      <Header as='h1'>Bienvenue</Header>

    </Container>

  </div>
)

export default HomeLayout



// WEBPACK FOOTER //
// ./src/layout/HomeLayout.js